import { render, staticRenderFns } from "./Thumbnail.vue?vue&type=template&id=190c67fb"
import script from "./Thumbnail.vue?vue&type=script&lang=js"
export * from "./Thumbnail.vue?vue&type=script&lang=js"
import style0 from "./Thumbnail.vue?vue&type=style&index=0&id=190c67fb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports